export const formatSeconds = (seconds: number | null | undefined): string => {
	if (!seconds || isNaN(seconds)) return '';
	const secondsToDate = new Date(0);
	secondsToDate.setSeconds(seconds);
	return secondsToDate.toISOString().substr(11, 8);
};
